// @flow

import {buildAdlFragmentFromParams} from '../components/AnalyticsDataLayer/buildAnalyticsDataLayer';

import type {SearchQueryStartAction} from '../actions/searchQuery';
import type {Store} from '../reducers';

export const updateAdlFromSearchParams = (
    store: Store,
    searchQueryStartAction: SearchQueryStartAction
) => {
    let prevFilterGroups;

    if (searchQueryStartAction) {
        const {
            prevData: {results: prevResults = {}}
        } = searchQueryStartAction.payload;

        prevFilterGroups = prevResults.filterGroups;
    }

    const updateForAdl = buildAdlFragmentFromParams(store, prevFilterGroups);

    window.analyticsdatalayer = {
        ...window.analyticsdatalayer,
        ...updateForAdl
    };
};
